export const container='flex items-center justify-center min-h-screen'
export const card='w-4/5 flex justify-center items-center  mx-4 rounded-none'
export const headerMessageDiv='flex justify-center items-center my-3'
export const headerMessage='text-sm font-bold text-center'
export const verifyButton ="bg-custom-button-green"
export const resendButton ="border border-custom-button-green text-white hover:bg-green-800"

export const buttomDiv= 'my-2 text-center'
export const buttomDivPara ='text-black text-sm font-bold'
export const linkText ='text-green-700'


